/* eslint-disable max-lines */
/* eslint-disable max-statements */
import styled from 'styled-components'
import React, { Fragment, useEffect, useState } from 'react'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Card from '@taglivros/oef_componentes/build/components/card'
import Toast from '@taglivros/oef_componentes/build/components/toast'
import { useGlobal } from '../../../contexts/GlobalContext'
import { useCartaoCredito } from '../../../contexts/CartaoCreditoContext'
import {
  TITULO_PAGINA,
  TEXTO_MODAL_EXCLUSAO_CARTAO,
  TITULO_ADICIONAR_CARTAO,
  MODAL_CONFIRMAR,
  MODAL_CANCELAR
} from './constantsPagamentoCartaoCredito'
import CardAdicionar from '../../../components/CardAdicionar'
import CardCartao from '../components/CardCartao/CardCartao'
import ConteudoWrapper from '../../../components/ConteudoWrapper/ConteudoWrapper'
import ModalConfirmacao from '../../../components/ModalConfirmacao/ModalConfirmacao'
import BreadcrumbGlobal from '../../../components/BreadcrumbGlobal/BreadcrumbGlobal'
import CartaoCreditoForm from '../../../components/CartaoCreditoForm/CartaoCreditoForm'
import CardPagamentoResumo from '../components/CardPagamentoResumo/CardPagamentoResumo'
import ModalConfirmaCartaoVigente from '../components/ModalConfirmaCartaoVigente/ModalConfirmaCartaoVigente'
import ModalAvisoProcessamento from '../components/ModalAvisoProcessamento/ModalAvisoProcessamento'
import ModalTrocaDataCobranca from '../components/ModalTrocaDataCobranca/ModalTrocaDataCobranca'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import ModalCVV from '../../../components/ModalCVV/ModalCVV'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'
import { getAssinaturaDoAssociadoPorModalidade } from '../../../utils/helpers/helpersAssinatura'
import { PLANO_MENSAL } from '../../../constants'
import WrapperComponent from '../../../containers/Opcionais/WrapperComponent'

const TituloPagina = styled.h1`
  margin: 0 auto 10px;

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 0 auto;
  }
`

const WrapperToast = styled.div`
  .toast {
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
     margin-top: 20px;
    }
  }
  `
const WrapperOpcional = styled.div`
  max-width: 416px;
  margin-top: 20px;
  background: white;
  border-radius: 17px;
  .div-description {
    padding: 10px 10px 15px 17px;
  }
`
const opcional = {
  'texto': 'Nosso sistema ainda está validando o seu cartão, esse processo pode demorar alguns segundos, atualize a página e tente novamente.',
  'titulo': 'Cadastrei um novo cartão e não aparece para tornar como vigente.'
}

const PagamentoCartaoCredito = () => {
  const {
    cartaoAdicionado,
    cartaoExcluido,
    cartaoSelecionado,
    cartaoVigente,
    cartoesCadastrados,
    dataCobrancaModificada,
    deleteCartao,
    errosAutoCobranca,
    getCartoes,
    getInfosPagamento,
    infosPagamento,
    loading,
    loadingRemoveCartao,
    postCartao,
    postCartaoVigente,
    postNovaDataCobranca,
    realizarAutoCobranca,
    setCartaoAdicionado,
    setCartaoExcluido,
    setCartaoSelecionado,
    setDataCobrancaModificada,
    setSucessoAutoCobranca,
    setErroAutoCobranca,
    sucessoAutoCobranca,
    setErrosCartao
  } = useCartaoCredito()

  const [ toast, setToast ] = useState( {} )
  const [ modalCVV, setModalCVV ] = useState( false )
  const [ idAssinatura, setIdAssinatura ] = useState()
  const [ cartaoExclusao, setCartaoExclusao ] = useState()
  const [ modalExclusao, setModalExclusao ] = useState( false )
  const [ openFormulario, setOpenFormulario ] = useState( false )
  const [ modalConfirmacao, setModalConfirmacao ] = useState( false )
  const [ modalDataCobranca, setModalDataCobranca ] = useState( false )
  const [ modalProcessamento, setModalProcessamento ] = useState( false )
  const [ showHelper, setShowHelper ] = useState( false )
  const [ statusAssinatura, setStatusAssinatura ] = useState( '' )

  const { dadosGlobaisAssociado, modalidadeURL } = useGlobal()
  const datasPossiveisCobranca = infosPagamento.cicloCobranca && infosPagamento.cicloCobranca.opcoes
  useEffect( () => {
    if ( idAssinatura ) {
      getCartoes( idAssinatura )
    }
    setCartaoSelecionado( {} )
  }, [ idAssinatura ] )

  useEffect( () => {
    if ( cartoesCadastrados?.length > 0 ) {
      const cardsWithNoiDGatway = cartoesCadastrados.filter( cartao => !cartao.soft_delete && cartao.idGateway === '' )

      if ( cardsWithNoiDGatway.length > 0 ) {
        setShowHelper( true )
      } else {
        setShowHelper( false )
      }
    }
  }, [ cartoesCadastrados ] )

  useEffect(
    () => {
      if ( dadosGlobaisAssociado ) {
        const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade(
          dadosGlobaisAssociado.assinaturas,
          modalidadeURL
        )
        if ( assinaturaObtida ) {
          setStatusAssinatura( assinaturaObtida.status )
          setIdAssinatura( assinaturaObtida.id )
        }
      }
    },
    [ dadosGlobaisAssociado ]
  )

  useEffect( () => {
    if ( idAssinatura ) {
      getInfosPagamento( idAssinatura, dadosGlobaisAssociado.assinaturas )
    }
  }, [ idAssinatura ] )

  useEffect( () => {
    if ( cartaoSelecionado && Object.keys( cartaoSelecionado ).length ) {
      setModalConfirmacao( true )
    }
  }, [ cartaoSelecionado ] )

  useEffect( () => {
    setModalCVV( false )
    setToast( {
      'funcao': () => setSucessoAutoCobranca( false ),
      'message': 'Cobrança realizada com sucesso!',
      'show': sucessoAutoCobranca
    } )
  }, [ sucessoAutoCobranca ] )

  useEffect( () => {
    setToast( {
      'funcao': () => setCartaoAdicionado( false ),
      'message': 'Cartão adicionado com sucesso!',
      'show': cartaoAdicionado
    } )

    setOpenFormulario( false )
  }, [ cartaoAdicionado ] )

  useEffect( () => {
    setToast( {
      'funcao': () => setCartaoExcluido( false ),
      'message': 'Cartão excluído com sucesso!',
      'show': cartaoExcluido
    } )
  }, [ cartaoExcluido ] )

  useEffect( () => {
    setToast( {
      'funcao': () => setDataCobrancaModificada( false ),
      'message': 'Data de cobrança modificada com sucesso!',
      'show': dataCobrancaModificada
    } )
  }, [ dataCobrancaModificada ] )

  const isVigente = item => {
    if ( cartaoVigente ) {
      return item.id === cartaoVigente.id
    } else {
      return item.vigencia.assinaturas.includes( idAssinatura )
    }
  }
  const usarComoVigente = cartao => {
    setCartaoSelecionado( cartao )
  }

  const confirmaExclusao = cartaoId => {
    setCartaoExclusao( cartaoId )
    setModalExclusao( true )
  }

  const excluirCartao = cartaoId => {
    deleteCartao( cartaoId, idAssinatura )
    setModalExclusao( false )
  }

  const onCancelarVigente = () => {
    setModalConfirmacao( false )
    setCartaoSelecionado( {} )
    getCartoes( idAssinatura )
  }

  const onConfirmarVigente = cartao => {
    postCartaoVigente( cartao, idAssinatura )
    setModalConfirmacao( false )
    setOpenFormulario( false )
  }

  const hideModalProcessamento = () => {
    setModalProcessamento( false )
  }

  const cadastraCartao = cartao => {
    postCartao( cartao, idAssinatura, hideModalProcessamento )
    setModalProcessamento( !modalProcessamento )
  }

  const cancelarCadastroCartao = () => {
    setOpenFormulario( false )
    setErrosCartao( {} )
  }

  const onConfirmarMundancaDataCobranca = novaDataCobranca => {
    postNovaDataCobranca( novaDataCobranca, idAssinatura )
    setModalDataCobranca( false )
  }

  const ofereceEdicaoDataCobranca = () => {
    setModalDataCobranca( true )
  }

  const pedeCvvPagamentoAutoCobranca = () => {
    setModalCVV( true )
  }

  const finalizarPagamentoAutoCobranca = CVV => {
    realizarAutoCobranca( CVV, idAssinatura )
  }

  return (
    <Fragment>
      {modalConfirmacao && !isEmptyObject( cartaoSelecionado ) ?
        <ModalConfirmaCartaoVigente
          cartaoAdicionado={ cartaoSelecionado }
          cartaoVigente={ cartaoVigente }
          onCancelar={ () => onCancelarVigente() }
          onConfirmar={ () => onConfirmarVigente( cartaoSelecionado ) }
          open={ modalConfirmacao }
        /> : null}

      {modalProcessamento ?
        <ModalAvisoProcessamento
          onCancelar={ () => setModalProcessamento( !modalProcessamento ) }
          open={ modalProcessamento }
        /> : null}

      {modalExclusao ?
        <ModalConfirmacao
          acaoPrimariaTitulo={ MODAL_CONFIRMAR }
          acaoSecundariaTitulo={ MODAL_CANCELAR }
          onClickAcaoPrimaria={ () => excluirCartao( cartaoExclusao ) }
          onClickAcaoSecundaria={ () => setModalExclusao( false ) }
          titulo={ TEXTO_MODAL_EXCLUSAO_CARTAO }
        /> : null}

      {modalCVV ?
        <ModalCVV
          acaoPrimariaTitulo={ MODAL_CONFIRMAR }
          acaoSecundariaTitulo={ MODAL_CANCELAR }
          errosAutoCobranca={ errosAutoCobranca }
          fecharModal={ () => {
            setModalCVV( false )
            setErroAutoCobranca( null )
          } }
          limparErros={ () => {
            setErroAutoCobranca( null )
          } }
          loading={ loading }
          onClickAcaoPrimaria={ CVV => finalizarPagamentoAutoCobranca( CVV ) }
          onClickAcaoSecundaria={ () => {
            setModalCVV( false )
            setErroAutoCobranca( null )
          } }
          open={ modalCVV }
        /> : null}

      {modalDataCobranca && datasPossiveisCobranca ?
        <ModalTrocaDataCobranca
          closeModal={ () => setModalDataCobranca( false ) }
          datasPossiveisCobranca={ datasPossiveisCobranca }
          diaCobrancaAtual={
            infosPagamento.cicloCobranca ? infosPagamento.cicloCobranca.dia.toString() : null
          }
          onCancelar={ () => setModalDataCobranca( false ) }
          onConfirmar={ idNovaDataCobranca => onConfirmarMundancaDataCobranca( idNovaDataCobranca ) }
          showModal={ modalDataCobranca }
        /> : null}

      <BreadcrumbGlobal
        exactPath="pagamento"
        nomeAlternativo="Pagamento"
        padding="20px 0"
      />

      <TituloPagina>{TITULO_PAGINA}</TituloPagina>

      <WrapperToast>
        <Toast
          close={ toast.funcao ? toast.funcao : () => {} }
          fullWidth={ true }
          message={ toast.message ? toast.message : '' }
          show={ toast.show }
          type="success"
        />
      </WrapperToast>

      {showHelper ?
        <WrapperOpcional>
          <WrapperComponent opcional={ opcional } />
        </WrapperOpcional> : null}

      {cartoesCadastrados ? (
        <ConteudoWrapper>
          {!isEmptyObject( infosPagamento ) && (
            <CardPagamentoResumo
              acaoPlanoPendente={ infosPagamento.acaoDePlanoPendente }
              diaCobranca={
                infosPagamento.cicloCobranca ? infosPagamento.cicloCobranca.dia : null
              }
              mesTagUltimoKitPago={
                infosPagamento.mesTagUltimoPedidoPago.visualizador
              }
              metodoPagamento={ infosPagamento.metodoPagamento }
              onEditarDataCobranca={ () => ofereceEdicaoDataCobranca() }
              parcelas={ infosPagamento.parcelas }
              pedeCvvPagamentoAutoCobranca={ () => pedeCvvPagamentoAutoCobranca() }
              podeAutoCobrar={ infosPagamento.podeAutoCobrar }
              tipoPlano={ infosPagamento.tipoPlano }
              urlBoleto={ infosPagamento.urlBoleto }
              urlQrCode={ infosPagamento.urlQrCode }
              valor={ infosPagamento.valorLiquido }
              vigenciaPendente={
                infosPagamento.tipoPlano === PLANO_MENSAL.visualizacao &&
                infosPagamento.cicloCobranca ? infosPagamento.cicloCobranca.vigencia.pendente : null
              }
            />
          )}

          {cartoesCadastrados.map( item => (
            <CardCartao
              ativo={ isVigente( item ) }
              botaoExcluir={ !isVigente( item ) || statusAssinatura === 'Cancelado' }
              cartao={ item }
              isVigente={ isVigente( item ) }
              key={ item.id }
              loading={ loadingRemoveCartao === item.id }
              onExcluir={ () => confirmaExclusao( item.id ) }
              showExcluir={ !loading && !loadingRemoveCartao }
              usarComoVigente={ () => usarComoVigente( item ) }
            />
          ) )}

          {!openFormulario ? (
            <CardAdicionar
              margin={ StyleGuide.isMobile() ? '20px auto' : '0 0 30px' }
              onClick={ () => setOpenFormulario( true ) }
              titulo={ TITULO_ADICIONAR_CARTAO }
            />
          ) : (
            <Card
              className="card"
              padding="25px"
            >
              <CartaoCreditoForm
                loading={ loading }
                onCancelar={ () => cancelarCadastroCartao() }
                onConfirmar={ cartaoRetornado => cadastraCartao( cartaoRetornado ) }
              />
            </Card>
          )}
        </ConteudoWrapper>
      ) : (
        <InlineLoader isCenter />
      )}
    </Fragment>
  )
}

export default PagamentoCartaoCredito
